import { qlikClient } from 'constants/environmental';
import config from 'coeus.config';

const SAAS = config.saas_client === qlikClient.SAAS;

export const convertQApps = (list, publishedOnly = true) =>
    SAAS ? convertSaasApps(list) : convertApps(list, publishedOnly);

const convertApps = (list, publishedOnly) =>
    list
        .filter((item) => {
            if (publishedOnly) {
                if (item.qMeta.published) {
                    return item;
                }
            } else {
                return item;
            }
        })
        .map(({ qDocName, qDocId }) => ({
            label: qDocName,
            value: qDocId,
        }));

const convertSaasApps = (list) =>
    list.map(({ name, resourceId }) => ({
        label: name,
        value: resourceId,
    }));

export const convertMasterApps = (list) => {
    return list.map(({ _id, title }) => ({
        label: title,
        value: _id,
    }));
};

export const convertSpaces = (list) => {
    return list.map(({ id, name }) => ({
        label: name,
        value: id,
    }));
};

export const convertQSpaces = (list) => {
    return list.map(({ id, name }) => ({
        title: name,
        key: id,
    }));
};

export const convertSheets = (list) =>
    list.map((item) => ({
        label: item.qMeta.title,
        value: item.qInfo.qId,
    }));

export const convertObjects = (list) =>
    list.map((item) => ({
        label: item.type,
        value: item.name,
    }));

export const convertPages = (list) =>
    list.map((item) => ({
        label: item.title,
        value: item.id,
    }));

export const addNone = (list) => [
    {
        label: 'None',
        value: '0',
    },
    ...list,
];

export const convertForms = (list) =>
    list.map((item) => ({
        value: item._id,
        label: item.name,
    }));
